import { useEffect } from 'react';
import http from 'hub-http/clients/apiClient';
import { useHistory } from 'react-router-dom';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { hubletApi, resolveApi } from 'hub-http/middlewares/core';
import { VIDEO_TIMESTAMP_PARAM } from './videoConstants';
// @ts-expect-error cannot find  typed file
import { useSearchParam } from '../../hooks/searchParamHooks';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
export const useVideoParams = () => {
  const [[startTime]] = useSearchParam(VIDEO_TIMESTAMP_PARAM);
  return {
    startTime: startTime ? Number(startTime) : undefined
  };
};
export const useAutoClearVideoVTS = () => {
  const {
    startTime
  } = useVideoParams();
  const history = useHistory();
  useEffect(() => () => {
    if (startTime) {
      const searchParams = new URLSearchParams(history.location.search);
      searchParams.delete(VIDEO_TIMESTAMP_PARAM);
      history.replace(Object.assign({}, history.location, {
        search: searchParams.toString()
      }));
    }
  }, [history, startTime]);
};
const videoPlayerConfigDefaultState = {
  autoPlay: false,
  playSpeed: 100
};
export const useVideoPlayerConfig = create()(persist(set => Object.assign({}, videoPlayerConfigDefaultState, {
  toggleAutoPlay() {
    set(state => ({
      autoPlay: !state.autoPlay
    }));
  },
  setPlaySpeed(speed) {
    set({
      playSpeed: speed
    });
  },
  setSubtitleLanguage(subtitleLanguage) {
    set({
      subtitleLanguage
    });
  }
}), {
  name: 'academy:videoPreferences'
}));
export const resetVideoPlayerConfig = () => useVideoPlayerConfig.setState(videoPlayerConfigDefaultState);
export const useVideoTimestamp = create(set => ({
  videoTimestamp: 0,
  setVideoTimestamp: timestamp => set({
    videoTimestamp: timestamp
  })
}));
export const getVideoCaptionData = (videoId, creatorRegion, creatorHubId) => {
  return http.get(`https://${resolveApi(hubletApi('api', 'hubspot', creatorRegion))}/video/v1/public/${videoId}/subtitles?portalId=${creatorHubId}`);
};
export const GET_VIDEO_CAPTION_DATA = registerQuery({
  fieldName: 'captionData',
  args: ['videoId', 'creatorRegion', 'creatorHubId'],
  fetcher({
    videoId,
    creatorRegion,
    creatorHubId
  }) {
    if (videoId && creatorRegion && creatorHubId) return getVideoCaptionData(videoId, creatorRegion, creatorHubId);
    return undefined;
  }
});
export const useVideoPlayerCaptions = (videoId, creatorRegion, creatorHubId, options) => {
  const {
    data: videoCaptionData,
    loading: videoCaptionDataLoading
  } = useQuery(GET_VIDEO_CAPTION_DATA, Object.assign({
    variables: {
      videoId,
      creatorRegion,
      creatorHubId
    }
  }, options));
  const languagesWithCaptions = Object.keys(videoCaptionData || {});
  return {
    captionsAvailable: !!languagesWithCaptions.length,
    captionsLoading: videoCaptionDataLoading,
    languagesWithCaptions
  };
};